import jwt from "@/http/requests/auth/jwt"
const actions = {

  // /////////////////////////////////////////////
  // COMPONENTS
  // /////////////////////////////////////////////

  // Vertical NavMenu
  updateVerticalNavMenuWidth({ commit }, width) {
    commit("UPDATE_VERTICAL_NAV_MENU_WIDTH", width)
  },

  // VxAutoSuggest
  updateStarredPage({ commit }, payload) {
    commit("UPDATE_STARRED_PAGE", payload)
  },

  // The Navbar
  arrangeStarredPagesLimited({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_LIMITED", list)
  },
  arrangeStarredPagesMore({ commit }, list) {
    commit("ARRANGE_STARRED_PAGES_MORE", list)
  },

  // /////////////////////////////////////////////
  // UI
  // /////////////////////////////////////////////

  toggleContentOverlay({ commit }) {
    commit("TOGGLE_CONTENT_OVERLAY")
  },
  updateTheme({ commit }, val) {
    commit("UPDATE_THEME", val)
  },

  // /////////////////////////////////////////////
  // User/Account
  // /////////////////////////////////////////////

  updateUserInfo({ commit }, payload) {
    commit("UPDATE_USER_INFO", payload)
  },
  updateUserRole({ dispatch }, payload) {
    // Change client side
    payload.aclChangeRole(payload.userRole)

    // Make API call to server for changing role

    // Change userInfo in localStorage and store
    dispatch("updateUserInfo", { userRole: payload.userRole })
  },
  updateActiveOrganisation ({ commit, dispatch }, payload) {
    commit("UPDATE_ACTIVE_ORGANISATION", payload)
    dispatch("refreshCampaigns", payload)
  },
  refreshCampaigns ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_IS_LOADING", true)
      const url = `/api/organisation/${payload}/campaigns`

      jwt
        .get(url, { isActive: true })
        .then((response) => {
          commit("UPDATE_USER_CAMPAIGNS", { campaigns: response.data.items })
          commit("SET_IS_LOADING", false)
          resolve(response)
        })
        .catch((error) => {
          commit("SET_IS_LOADING", false)
          reject(error)
        })
    })
  },
  updateLocale ({ commit }, locale) {
    commit("UPDATE_USER_INFO", { language: locale })
  },
  updateActiveCampaign ({ commit, dispatch }, payload) {
    commit("UPDATE_ACTIVE_CAMPAIGN", payload)
  },
  refreshStrategies ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      commit("SET_IS_LOADING", true)
      const url = `/api/strategy/${payload}/list`

      jwt
        .get(url, { isActive: true })
        .then((response) => {
          console.log("UPDATE_USER_STRATEGIES", response.data.items)
          commit("UPDATE_USER_STRATEGIES", { strategies: response.data.items })
          commit("SET_IS_LOADING", false)
          resolve(response)
        })
        .catch((error) => {
          commit("SET_IS_LOADING", false)
          reject(error)
        })
    })
  },
  updateActiveStrategy ({ commit }, payload) {
    commit("UPDATE_ACTIVE_STRATEGY", payload)
  },

}

export default actions